import { NodeCanvas } from './canvas';
import { NodeContext2d } from './context';
import { createModule } from '../create-canvas-module';

export const nodeCanvasModule = createModule(NodeCanvas, NodeContext2d);
